<template>
  <div>
    <div :class="`pb-${marginBottom}`">
      <v-alert :class="`${type}--text`" border="left" class="mb-0 text-body-2 text-sm-body-1" text>
        <v-row no-gutters>
          <v-col v-if="'success' === type" cols="auto" class="pl-2">
            <v-icon :color="type">fa-light fa-check-circle</v-icon>
          </v-col>
          <v-col v-if="'error' === type" cols="auto" class="pl-2">
            <v-icon :color="type">fa-light fa-message-exclamation</v-icon>
          </v-col>
          <v-col class="black--text pl-4">
            <slot />
          </v-col>
        </v-row>
      </v-alert>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: null,
    },
    marginBottom: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="scss" scoped>
.v-alert {
  ::v-deep(.v-alert__border) {
    opacity: 1;
  }
}
</style>
